import { useEffect } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { useFirstInteraction } from "@/hooks/use-first-interaction";

const SCRIPT_SRC = "https://reputationhub.site/reputation/assets/review-widget.js";

const ReviewWidget = () => {
  // The review widget (script + cross-origin iframe) is loaded on first user
  // interaction so its network + main-thread cost stays off the critical path.
  const ready = useFirstInteraction();

  useEffect(() => {
    if (!ready) return;
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);
  }, [ready]);

  return (
    <section className="section-padding bg-muted/30">
      <div className="container-max">
        <div className="text-center mb-10">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block text-primary text-sm font-bold uppercase tracking-widest mb-3"
          >
            Reviews
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading text-4xl md:text-5xl text-foreground mb-4 tracking-tight font-bold"
          >
            What Our <span className="text-gradient-primary">Clients</span> Say
          </motion.h2>
          <div className="flex items-center justify-center gap-1 mb-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-5 w-5 fill-secondary text-secondary" />
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-5xl mx-auto"
        >
          {ready ? (
            <iframe
              className="lc_reviews_widget"
              src="https://reputationhub.site/reputation/widgets/review_widget/UynRWXklDKuUu9ESCybq?widgetId=6a60f02f6d3785936f392e61"
              frameBorder="0"
              scrolling="no"
              style={{ minWidth: "100%", width: "100%", minHeight: "220px" }}
              title="JR Pro Cleaning Services Reviews"
            />
          ) : (
            <div
              className="w-full rounded-lg bg-muted/40 animate-pulse"
              style={{ minHeight: "220px" }}
              aria-hidden="true"
            />
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default ReviewWidget;
